// ** Redux Imports
import { createSlice } from "@reduxjs/toolkit";
import { appConstants } from "constants/appConstants";

export const langSlice = createSlice({
  name: "lang",
  initialState: {
    language: appConstants.LANGUAGE.DEFAULT_LANGUAGE,
  },
  reducers: {
    setLanguage: (state, action) => {
      state.language = action.payload;
    },
  },
});
export const { setLanguage } = langSlice.actions;

export default langSlice.reducer;
